export default function parseDecimalNumber(numberStr: string) {
  if (!numberStr?.length) return null;
  return Number(numberStr.replace(',', '.'));
}
